module.exports = __webpack_public_path__ + "img/resolute1.5e58de94.png";